// extracted by mini-css-extract-plugin
export default {"picker":"picker___VJ6xn","icon":"icon___qCoxq"};